import type { ReactNode } from 'react';

import { Button } from './button';

export interface ToggleGroupItem {
  value: string;
  label: string;
  icon: ReactNode;
}

interface ToggleGroupProps {
  ariaLabel: string;
  className?: string;
  items: ToggleGroupItem[];
  value: string;
  onChange: (value: string) => void;
}

export const ToggleGroup = ({ ariaLabel, className = '', items, value, onChange }: ToggleGroupProps) => (
  <div className={`toggle-group ${className}`.trim()} role="group" aria-label={ariaLabel}>
    {items.map((item) => {
      const active = item.value === value;
      return (
        <Button
          variant="plain"
          className={`toggle-group-item ${active ? 'active' : ''}`.trim()}
          aria-label={item.label}
          aria-pressed={active}
          title={item.label}
          key={item.value}
          onClick={() => onChange(item.value)}
        >
          {item.icon}
        </Button>
      );
    })}
  </div>
);
